export const PUBNUB_AUTH_V1_ENDPOINT = '/c/v1/pubnub/auth';
export const PUBNUB_AUTH_V2_ENDPOINT = '/c/v2/pubnub/auth';
